module.exports = __webpack_public_path__ + "static/img/zh-HK.d7bed4ba.svg";